/**
 * storageProvider
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

/**
 * @property {Storage} storage
 */
export class StorageService {
    private storage: Storage;

    constructor($window: ng.IWindowService) {
        this.storage = $window.localStorage;
    }

    set(key: string, value: string) {
        try {
            this.storage.setItem(key, value);
        } catch (e) {
            if (e.message.includes('quota')) {
                this.clearEvents();
                this.set(key, value);
            }
        }

        return value;
    }

    private clearEvents() {
        // Remove all old event data
        for (const k in this.storage) {
            if (k.startsWith('event:')) {
                this.storage.removeItem(k);
            }
        }
    }

    get(key: string, defaultValue: any) {
        return this.storage.getItem(key) || defaultValue;
    }

    has(key: string): boolean {
        return this.storage.getItem(key) !== null;
    }

    /**
     *
     * @param {string} key
     * @param {boolean} defaultValue
     */
    getBoolean(key, defaultValue) {
        const value = this.get(key, defaultValue);

        if (value === 'false') {
            return false;
        }

        return Boolean(value);
    }

    remove(key) {
        return this.storage.removeItem(key);
    }

    clear() {
        this.storage.clear();
    }
}

StorageService.$inject = ['$window'];

export function storageProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(StorageService);
    }
}
